import { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { Col, Row, Typography, Divider } from 'antd'
import { Link } from 'react-router-dom'
import Icon from '@ant-design/icons'
import { useChilizStore, useChilizConfigProvider } from '../stores'

import { AccountImage } from '../components/AccountImage'
import { Copy } from '../components/Copy'
import { ExplorerLink } from '../components/ExplorerLink'

import { ReactComponent as ExternalLink } from '../assets/icons/ExternalLink.svg'
import Page from './Page'
import { NFTCard } from '../components/NFTCard'

const { Title, Text } = Typography

const MyWalletPage = observer(() => {
  const store = useChilizStore()
  const configProvider = useChilizConfigProvider()
  const [currentAccount, setCurrentAccount] = useState('')

  useEffect(() => {
    if (store.isConnected) {
      setCurrentAccount(store.getKeyProvider().currentAccount())
    }
  }, [store.isConnected])

  if (!store.isConnected) {
    return <Page className={'pd-10'}><h1>Connecting... </h1><h2>Verify the network you are connnected to.</h2></Page>
  }

  return (
    <Page className={'pd-top-page'}>
    <Col>
      <Row>
        <Col span={24}>
          <Title style={{ fontFamily: 'PP Neue Machina', fontWeight: 400, marginBottom: 0 }} level={1} className="page-title">My Wallet</Title>
          <Divider />
        </Col>
      </Row>

      <Col>
        <Row justify="center" style={{ background: 'linear-gradient(180deg, #232E3E 65%, transparent 35%)', paddingTop: '60px', marginBottom: '20px' }}>
          <AccountImage account={currentAccount} showMetamaskLogo={true} size={100}/>
        </Row>
        <Row justify='center' style={{ marginBottom: '10px' }}>{currentAccount}</Row>
        <Row justify='center' gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ fontSize: 14, marginBottom: '20px' }}>
          <Col><Copy text={currentAccount}>Copy Address</Copy></Col>
          <Col>
            <ExplorerLink hash={currentAccount} type='address' customTitle={<Text><Icon component={ExternalLink} className='wallet-detail-composition-icon'/>View on Explorer</Text>}/>
          </Col>
        </Row>
        <Row justify='center'><Text style={{ color: '#CC1024', fontSize: 14 }}>{configProvider.getChainConfig().chainName}</Text></Row>
      </Col>

      <Row>
        <Col span={24}>
          <Title style={{ fontFamily: 'PP Neue Machina', fontWeight: 400, marginBottom: 0 }} level={2} className="page-title">My NFTs</Title>
          <Divider />
        </Col>
      </Row>

      {store.userNfts.length === 0 && <Row justify='center'><Text>{"You don't have any NFTs"}</Text></Row>}

      <Row>
      {store.userNfts.map((nft, i) => (
        <Col lg={4} sm={24} xs={24} md={24} key={nft.tokenId}>
          <Link to={`/nfts/${nft.address}/${nft.tokenId}`} state={{ from: { path: '/my-wallet', name: 'My Wallet' } }}>
            <NFTCard title={`${(nft.name)} - #${(nft.tokenId)}`} cover={nft.image}/>
          </Link>
        </Col>
      ))}
      </Row>
    </Col>
    </Page>
  )
})

export default MyWalletPage
